import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getRemovablePreferenceDefaults } from "../removablePreferenceForm";

const BASES = ["Résine", "Résine injectée", "Valplast"];
const TEETH_SHADES = [
  "A1",
  "A2",
  "A3",
  "A3.5",
  "A4",
  "B1",
  "B2",
  "B3",
  "B4",
  "C1",
  "C2",
  "C3",
  "C4",
  "D2",
  "D3",
  "D4",
];
const REINFORCEMENTS = [
  "Sans renfort",
  "Armature métallique",
  "Grille de renfort",
];
const TEETH = ["Dents du commerce", "Dent composite"];
const PERIPHERAL_SEALS = ["Standard", "Renforcé"];

export const CompleteDenturePreferences = withForm({
  defaultValues: getRemovablePreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "completeBase",
      "completeTeethShade",
      "completeReinforcement",
      "completeTeeth",
      "completePeripheralSeal",
    ]);

    return (
      <SaveableCard
        title="Amovible complète"
        description="Base et dents habituelles"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Base</Text>
              <form.Field name="completeBase">
                {field => (
                  <Select
                    data={BASES}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Teinte des dents</Text>
              <form.Field name="completeTeethShade">
                {field => (
                  <Select
                    data={TEETH_SHADES}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Text variant="strong">Renfort</Text>
            <form.Field name="completeReinforcement">
              {field => (
                <Group>
                  {REINFORCEMENTS.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">Dents</Text>
            <form.Field name="completeTeeth">
              {field => (
                <Group>
                  {TEETH.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">Joint périphérique</Text>
            <form.Field name="completePeripheralSeal">
              {field => (
                <Group>
                  {PERIPHERAL_SEALS.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
